// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_ATm","toggle":"styles_toggle__3Ayxn","preview":"styles_preview__1xInl"};